import _ from 'lodash';

const { omit } = _

export const getParams = () => {
    const hashPrefixReg = /#\/.*?\/?\?/;
    const queryByHash = window.location.hash.split(hashPrefixReg)[1] || '';
    const queryObj: Record<string, string> = {};
    const searchParams = new URLSearchParams(queryByHash);
    searchParams.forEach((value, key) => {
        queryObj[key] = value;
    })
    return queryObj;
};

/**
 * 从 url 获取参数，可通过制定 excludes 参数设置排除项
 * @param {*} param
 */
export const getViewParams = ({ excludes = [] } = {}) => {
    const queryObj = getParams();

    const viewParams = Object.assign(queryObj, {
        hasValidHash: true,
        patentId: queryObj.patentId,
    });

    // @ts-ignore
    viewParams.page = (() => {
        const cacheKey = `listOnPage:${queryObj.patentId}`;
        const cachePage = sessionStorage.getItem(cacheKey);
        const viewParamPage = viewParams.page;

        let page;

        if (queryObj.patentId === queryObj.related_id) {
            page = viewParamPage || cachePage;
        } else {
            page = cachePage || viewParamPage;
        }
        return parseInt(`${page}`);
    })();

    // @ts-ignore
    if (isNaN(viewParams.page)) {
        delete viewParams.page;
    }

    if (excludes.length === 0) {
        return viewParams;
    }

    return omit(viewParams, excludes) as any;
};

interface IViewParams {
    isSingleView: boolean
    isCompareView: boolean
    rightPatentId?: string
    leftPatentId?: string
    neighborhoodsNames: {
        left: string
        right: string
    }
    page: number
}
export function getViewParamsByRoute(route: any) {
    const viewParams = { ...route.query } as unknown as IViewParams;
    const patentId = route.query.patentId || route.query.related_id;

    viewParams.isSingleView = !route.params.right;
    viewParams.neighborhoodsNames = {
        left: route.params.left,
        right: route.params.right,
    };

    viewParams.page = (() => {
        const cacheKey = `listOnPage:${patentId}`;
        const cachePage = sessionStorage.getItem(cacheKey);
        const viewParamPage = viewParams.page;

        let page;

        if (route.query.patentId === route.query.related_id) {
            page = viewParamPage || cachePage;
        } else {
            page = cachePage || viewParamPage;
        }
        return parseInt(`${page}`);
    })();

    if (isNaN(viewParams.page)) {
        // @ts-ignore
        delete viewParams.page;
    }

    return viewParams;
}

export function defaultViewPropsGetter(route: any) {
    const viewParams = getViewParamsByRoute(route);
    return { viewParams };
}
